import React, { useEffect, useState } from "react";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import BXPDetails from "../MergersAcquisitions/BXPDetails";
import { TabContent, TabPane } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteMerger,
  getMergerById,
  getMineMergerList,
} from "../../../../redux/mergers/action";
import MergersAcquisitionList from "../ALLOTSProductsLists/MergersAcquisitionList";
import Access from "../../../CustomComponents/Access/Access";
import { useLocation } from "react-router-dom";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import TranslatedText from "../../../Common/TranslatedText";
import ImportantNoteOTS from "../../../Common/ImportantNote/ImportantNoteOTS";
import CloseConfirmModal from "../../../Common/CloseConfirmModal";
import useConfirmRefresh from "../../../../utils/useConfirmRefresh";
import ConfirmModal from "../../../Common/ConfirmModal";

export default function PackagedService({ autoOpen }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState("");
  const [activeTab, setActiveTab] = useState("BXPDetails");
  const [modalOpen, setModalOpen] = useState(false);
  const [updateindex, setUpdateindex] = useState(null);
  const [bxpDataList, setbxpDataList] = useState("");
  const [bxpData, setbxpData] = useState("");
  const [modal, setModal] = useState(false);
  const [changesIsThere, setChangesIsThere] = useState(false);
  const [showDraftModal, setShowDraftModal] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const packageId = queryParams.get("mergerid");

  const closeModal = () => {
    setModalOpen(false);
    setModal(false);
  };

  const modalStyle = {
    right: modalOpen ? "0" : "-100%",
  };
  useEffect(() => {
    scrollToTop();
  }, [activeTab]);

  useEffect(() => {
    setbxpDataList(formData?.bxp);
  }, [bxpData]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const dispatch = useDispatch();
  const getminemergerslist = useSelector(
    ({ mergers: { getminemergerslist } }) => getminemergerslist
  );
  const getmergersbyid = useSelector(
    ({ mergers: { getmergersbyid } }) => getmergersbyid
  );

  useEffect(() => {
    dispatch(getMineMergerList());
  }, []);

  const { setOTSAutoOpen } = useRouteBaseStateContext();

  useEffect(() => {
    if (autoOpen) {
      checkaccessss();
      setOTSAutoOpen(false);
    }
  }, [autoOpen]);

  useEffect(() => {
    const isNotEmpty = getmergersbyid && Object.keys(getmergersbyid).length > 0;
    if (updateindex !== null) {
      if (isNotEmpty) {
        setbxpData(getmergersbyid);
      } else {
        setbxpData("");
      }
    }
  }, [getmergersbyid, updateindex]);

  const getBXPDATA = (id) => {
    dispatch(getMergerById(id));
  };

  useEffect(() => {
    packageId && updateBxp(packageId);
  }, [packageId]);
  const updateBxp = (index) => {
    setUpdateindex(index);
    getBXPDATA(index);
    setModalOpen(true);
    setActiveTab("BXPDetails");
  };

  const deleteee = (id) => {
    dispatch(deleteMerger(id, setLoading));
  };
  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modalOpen]);

  const openmodel = () => {
    const draft = localStorage.getItem("MAS_DRAFT");
    if (draft) {
      setShowDraftModal(true);
    } else {
      setModalOpen(true);
      setbxpData("");
      setActiveTab("BXPDetails");
      setUpdateindex(null);
    }
  };

  const handleConfirmDraft = () => {
    const draft = localStorage.getItem("MAS_DRAFT");
    if (draft) {
      setbxpData(JSON.parse(draft));
    }
    setModalOpen(true);
    setActiveTab("BXPDetails");
    setUpdateindex(null);
    setShowDraftModal(false);
  };

  const handleCancelDraft = () => {
    localStorage.removeItem("MAS_DRAFT");
    setModalOpen(true);
    setbxpData("");
    setActiveTab("BXPDetails");
    setUpdateindex(null);
    setShowDraftModal(false);
  };

  useEffect(() => {
    if (modalOpen && updateindex === null && bxpData && Object.keys(bxpData).length > 0) {
      localStorage.setItem("MAS_DRAFT", JSON.stringify(bxpData));
    }
  }, [bxpData, updateindex, modalOpen]);

  const checkaccessss = () => {
    setModal(true);
  };

  useConfirmRefresh(modalOpen ? true : false);

  return (
    <>
      <ConfirmModal
        isOpen={showDraftModal}
        toggle={() => setShowDraftModal(!showDraftModal)}
        title="Continue last edit?"
        message="Would you like to continue last edit?"
        onConfirm={handleConfirmDraft}
        onCancel={handleCancelDraft}
        confirmText="Yes"
        cancelText="No"
      />
      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          state={"state"}
          checkpermission={"create_mergers"}
          hitmethod={openmodel}
          checkrole={false}
        />
      ) : (
        ""
      )}

      <div>
        <div
          isOpen={modalOpen}
          keyboard={false}
          // className="add-education-modal add-bxp-modal"
          className={
            modalOpen
              ? `add-education-modal add-bxp-modal add-overlay-modal-width active`
              : "add-education-modal add-bxp-modal add-overlay-modal-width"
          }
          style={modalStyle}
        >
          <div className={`modal-overlay-sec   ${modalOpen ? 'active' : ''}`}></div>
          <div className="modal-width ">
            <div className="modal-head">
              <h3>
                {" "}
                {updateindex !== null ? "Edit" : "Add"} <TranslatedText i18nKey="MAS1" />
              </h3>
              <CloseConfirmModal closeModal={closeModal} type={updateindex != null ? "Edit" : "Add"} changesIsThere={updateindex ? true : activeTab != "BXPDetails" ? true : changesIsThere} />
            </div>
            <div className="tab-bxp">
              <TabContent activeTab={activeTab}>
                <TabPane tabId="BXPDetails">
                  <BXPDetails
                    updateindex={updateindex}
                    bxpData={bxpData}
                    setbxpData={setbxpData}
                    setActiveTab={setActiveTab}
                    setModalOpen={setModalOpen}
                    setModal={setModal}
                    key={modalOpen ? updateindex ?? "add" : "closed"}
                    setChangesIsThere={setChangesIsThere}
                  />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </div>

      <div className="packagedservice">
        <div className="packaged-first">
          <h4><TranslatedText i18nKey="MAS1" /></h4>
          <button
            className="buttons border-button"
            onClick={() => {
              checkaccessss();
            }}
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
              alt=""
            />
            Add
          </button>
        </div>
        {Object.keys(getminemergerslist).length > 0 ? <MergersAcquisitionList
          listing={getminemergerslist}
          update={updateBxp}
          deleteee={deleteee}
          setModalOpen={setModalOpen}
        /> : <PostNotFound title={"No Post Found"} height={200} />}
      </div>
    </>
  );
}
